export const GLOBAL = {
  STANDARD_WIDTH: 375,
} as const;

export const PROPERTY_TYPE: Array<string> = ["apartment", "house"];

// api url to LG backend server
let URL = process.env.REACT_APP_SERVER_URL;
// URL = "http://127.0.0.1:5000";
const API_URL: string = URL ? URL : "";
export const API_BUILDING_NAME = API_URL + "/building_name_phj";
export const API_BUILDING_DETAIL = API_URL + "/building_detail";
export const API_POSTCODE = API_URL + "/postcode";
export const API_VALUATION = API_URL + "/valuation";
export const API_IS_VALIDTOKEN = API_URL + "/is_valid_token";
